import React from "react";
import "./index.css";
import { Link } from "react-router-dom";

/* Constants */
import { candidateProfileHeaderLinks, candidateJobsHeaderLinks } from "../../constants";

/* Helpers */
import { compareArchived } from "../../helpers/job";

const sectionComplete = (path, profile) => {
    if (!profile) return false;
    switch (path) {
        case "/profile":
            return !!(profile.dob && profile.gender && profile.height && profile.country);
        case "/profile/ideal-job":
            return !!(profile.lookingFor?.desiredRoles?.length);
        case "/profile/qualifications":
            return !!(profile.eng1Info?.status || profile.stcwBasicInfo?.status || profile.qualifications?.length);
        case "/profile/experience":
            return !!(profile.pastRoles?.length || profile.education?.length);
        case "/profile/references":
            return !!profile.references?.length;
        case "/profile/documents":
            return !!(profile.cv || profile.documents?.length);
        default:
            return false;
    }
};

export default ({ user, match, editPhoto, newJobs, allJobs, applications }) => {

    const isProfile = match.path.includes("/profile");
    const profile = user?.data?.profile;

    if (isProfile) {
        return (
            <>
                <nav className="profile-nav" aria-label="Profile sections">
                    {candidateProfileHeaderLinks.map((link, index) => {
                        const active = match.path === link.path;
                        const complete = sectionComplete(link.path, profile);
                        return (
                            <Link to={link.path} key={index} className={`profile-nav-item${active ? " is-active" : ""}${complete ? " is-complete" : ""}`}>
                                <span className="profile-nav-number">{String(index + 1).padStart(2, "0")}</span>
                                <span className="profile-nav-title">{link.name}</span>
                                <span className="profile-nav-status" aria-hidden="true">
                                    {complete ? (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                            <path d="M5 13L9 17L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    ) : null}
                                </span>
                                {active && <span className="profile-nav-active-marker" aria-hidden="true" />}
                            </Link>
                        );
                    })}
                </nav>
            </>
        );
    }

    /* Jobs context - keep the old horizontal tab style */
    return (
        <>
            <div className="candidate-header-container">
                <div className="candidate-header-menu-container">
                    <div className="candidate-header-menu-wrapper">
                        {renderMenuLinks(candidateJobsHeaderLinks, match.path, "jobs", applications)}
                    </div>
                </div>
            </div>
            <div className="candidate-mobile-header-container">
                <div className="candidate-mobile-header-title-container">
                    <p className="candidate-mobile-header-title">Jobs</p>
                </div>
                {renderMobileMenuLinks(candidateJobsHeaderLinks, match.path)}
            </div>
        </>
    );

}

const renderMenuLinks = (links, path, type, applications) => {

    return links.map((link, index) => {
        return(
            <Link to={link.path} key={index}>
                <div className={type === "profile" ? "candidate-header-menu-item-container" : "candidate-header-menu-job-item-container"}>
                    <p className="candidate-header-menu-item-text">{link.name}{handleNumberOfItems(link.path, applications)}</p>
                    {path === link.path &&
                        <div className="candidate-header-menu-item-active"></div>
                    }
                </div>
            </Link>
        );
    });

}

const renderMobileMenuLinks = (links, path) => {

    return links.map((link, index) => {
        return(
            <Link to={link.path} key={index}>
                <div className="candidate-mobile-item-title-container" style={path === link.path ? {backgroundColor: "var(--jc-sand-100)"} : {}}>
                    <p className="candidate-mobile-item-title" style={{color: path === link.path ? "var(--jc-coral-600)" : "var(--jc-ink-700)"}}>{link.name}</p>
                </div>
            </Link>
        );
    });

}

const handleNumberOfItems = (path, applications) => {
    if (path === "/jobs/applications" && applications.length !== 0) {

        applications = applications.filter(application => {
            return !compareArchived(application.job.archived);
        });

        return ` (${applications.length})`;
    };

    return;

}
